<template>
  <!-- 
    This component provides a select list alternative that uses radio buttons styled as a drop down menu 
    Example Usage:
  
  <BaseSelectList v-on:selected="doSomething" :options="[ {'value':'1', 'label':'Last 7 days' }, {'value':'2', 'label':'Last 14 days' }, {'value':'3', 'label':'Last 30 days' }]"> </BaseSelectList>

   -->

  <div class="flex flex-wrap">
    <div class="px-4">
      <div
        v-on-clickaway="closeMenu"
        class="relative inline-flex align-middle w-full"
      >
        <button
          class="text-black font-semibold bg-transparent border border-solid border-gray-300 hover:border-gray-400 hover:bg-purple-200 hover:text-purple-700 active:bg-purple-300 text-xs px-4 py-2 outline-none focus:outline-none focus:ring focus:border-purple-500 rounded"
          type="button"
          style="transition: all .15s ease"
          v-on:click="toggleDropdown($event)"
          ref="btnDropdownRef"
        >
          {{ selectedLabel }}
        </button>

        <!-- Dropdown Menu -->
        <transition name="fade">
          <div
            ref="popoverDropdownRef"
            class="bg-white text-base z-50 float-left py-2 list-none text-left rounded shadow-lg mt-2"
            v-show="menuOpen"
            style="min-width: 12rem;border: 1px solid #e3e3e3"
          >
            <div v-for="(option, index) in options" :key="index">
              <label
                :for="'radio_' + option.value"
                class="text-sm py-2 px-4 font-normal block w-full whitespace-no-wrap bg-transparent text-gray-800 hover:bg-gray-100 hover:no-underline"
              >
                {{ option.label }}

                <input
                  type="radio"
                  :value="option.value"
                  :id="'radio_' + option.value"
                  v-model="selectedValue"
                  @click="itemSelect(option)"
                />
              </label>
            </div>
          </div>
        </transition>
        <!-- End Menu -->
      </div>
    </div>
  </div>
</template>
<script>
import Popper from "popper.js";
import { mixin as clickaway } from "vue-clickaway";
import { authUser } from "@/store/helpers.js";

export default {
  mixins: [clickaway],
  data() {
    return {
      menuOpen: false,
      selectedValue: 0,
      selectedLabel: "",
    };
  },
  props: ["options", "defaultLabel"],
  computed: {
    //import user and loggedIn status from our state helper
    ...authUser,
  },
  methods: {
    toggleDropdown: function(event) {
      event.preventDefault();
      if (this.menuOpen) {
        this.menuOpen = false;
      } else {
        this.menuOpen = true;
        new Popper(this.$refs.btnDropdownRef, this.$refs.popoverDropdownRef, {
          placement: "bottom-end",
        });
      }
    },
    itemSelect(option) {
      this.selectedLabel = option.label;
      this.menuOpen = false;

     this.$emit('selected', option.value);
      //To Do: 1. Submit selected value to a specified backend endpoint.
    },
    closeMenu: function() {
      this.menuOpen = false;
    },
    escapeKeyListener: function(evt) {
      if (evt.keyCode === 27 && this.menuOpen) {
        this.menuOpen = false;
      }
    }
  },
  created: function() {
    //if no default provided, set the initial label to the first array entry
    this.selectedLabel = this.defaultLabel ?? this.options[0].label;
    
    document.addEventListener("keyup", this.escapeKeyListener);
  },
  destroyed: function() {
    document.removeEventListener("keyup", this.escapeKeyListener);
  },
};
</script>

<style scoped>
input {
  visibility: hidden;
}
label {
  cursor: pointer;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.33s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
